import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Movie } from '../../types/movie';

interface CacheState {
  trending: Movie[];
  recent: Movie[];
  categories: string[];
  genres: string[];
  lastUpdated: number;
}

const initialState: CacheState = {
  trending: [],
  recent: [],
  categories: [],
  genres: [],
  lastUpdated: 0,
};

const cacheSlice = createSlice({
  name: 'cache',
  initialState,
  reducers: {
    setTrending: (state, action: PayloadAction<Movie[]>) => {
      state.trending = action.payload;
      state.lastUpdated = Date.now();
    },
    setRecent: (state, action: PayloadAction<Movie[]>) => {
      state.recent = action.payload;
      state.lastUpdated = Date.now();
    },
    setCategories: (state, action: PayloadAction<string[]>) => {
      state.categories = action.payload;
    },
    setGenres: (state, action: PayloadAction<string[]>) => {
      state.genres = action.payload;
    },
    clearCache: (state) => {
      state.trending = [];
      state.recent = [];
      state.lastUpdated = 0;
    },
  },
});

export const { 
  setTrending, 
  setRecent, 
  setCategories,
  setGenres, 
  clearCache 
} = cacheSlice.actions;

export default cacheSlice.reducer; 